import { MODULE } from "./collaborateLabels.actionTypes";

export const isLabelsDropdownVisible = (state) => {
  return state.getIn([MODULE, "isLabelsDropdownVisible"]) || false;
};

export const isSavingLabel = (state) => {
  return state.getIn([MODULE, "isSavingLabel"]) || false;
};

export const isFetchingLabels = (state) => {
  return state.getIn([MODULE, "isFetchingLabels"]) || false;
};

export const getLabels = (state) => {
  return state.getIn([MODULE, "labels"]) || [];
};

export const getSelectedLabels = (state) => {
  return state.getIn([MODULE, "selectedLabels"]) || [];
};

export const getUnSelectedLabels = (state) => {
  return state.getIn([MODULE, "unSelectedLabels"]) || [];
};

export const getActiveLabel = (state) => {
  return state.getIn([MODULE, "activeLabel"]) || null;
};

export const isCreateLabelFormVisible = (state) => {
  return state.getIn([MODULE, "isCreateLabelFormVisible"]) || false;
};

export const isDeleteLabelAlertVisible = (state) => {
  return state.getIn([MODULE, "isDeleteLabelAlertVisible"]) || false;
};
